import React, { useState, useEffect, useContext } from "react";
import ActorCard from "./ActorCard"; // This ActorCard will be used for Crew
// import { actorData } from "../dumyData";
import CrewSearchFilter from "./CrewSearchFilter"; // Import the new filter component
import Pagination from "@mui/material/Pagination";
import {
  Box,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  Typography,
  Slider,
  InputLabel,
  Input,
  InputAdornment,
  IconButton,
  Button // Added Button component for toggle
} from "@mui/material";
import nprogress from "nprogress";
import SearchIcon from "@mui/icons-material/Search";
import "nprogress/nprogress.css";
import { getAllActors, getAllCrews } from "../../api/axios";
import { Spinner } from "react-bootstrap";
// import ActorsSelectingList from "./ActorsSelectingList"; // Remove this import
import { useTheme } from "@mui/material/styles";
import { AuthContext } from "../../context/AuthContext";
import FilterListIcon from '@mui/icons-material/FilterList'; // Import filter icon
import CloseIcon from '@mui/icons-material/Close'; // Import close icon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Added for envelope icon
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'; // Added for envelope icon
import Alert from "../common/Alert"; // Added Alert component
import InvitationPopUp from "../actors/InvitationPopUp"; // Reusing InvitationPopUp
import useTalentSelection from "../../hooks/useTalentSelection"; // Import the custom hook

const ageMarks = [
  {
    value: 18,
    label: "18",
  },
  {
    value: 100,
    label: "100",
  },
];

function ageText(value) {
  return `${value}`;
}

const Genders = ["Male", "Female", "Non-Binary", "Transgender"];
const Ethnicities = [
  "Black",
  "White",
  "Asian",
  "Latino/Hispanic",
  "White/Caucasian",
  "Middle_Eastern",
  "Native_American",
  "Pacific_Islander",
  "Indian/South_Asian",
  "Other",
];
const ethnicities = [
  {
    value: "black",
    label: "African American",
  },
  {
    value: "white",
    label: "White",
  },
  {
    value: "asian",
    label: "Asian",
  },
  {
    value: "latino/hispanic",
    label: "Latino Hispanic",
  },
  {
    value: "white/caucasian",
    label: "European American",
  },
  {
    value: "middle_eastern",
    label: "Middle Eastern",
  },
  {
    value: "native_american",
    label: "Native American",
  },
  {
    value: "pacific_islander",
    label: "Pacific Islander",
  },
  {
    value: "indian/south_asian",
    label: "Indian South Asian",
  },
  {
    value: "other",
    label: "Other",
  },
];
const CrewList = () => {
  const theme = useTheme();
  const { role } = useContext(AuthContext);

  const userRole = localStorage.getItem("role"); // Get userRole for conditional rendering
  const producerId = localStorage.getItem("userId"); // Get producerId for InvitationPopUp

  const [searchInputs, setSearchInputs] = useState({
    name: "",
    country: "",
    zip: "",
    radius: "",
    age: [18, 100],
    gender: [],
    hobby: "",
    eyeColor: [],
    hairColor: [],
    weight: "",
    height: "",
    ethnicity: [],
    jobTitles: "", // Changed to string for single selection
  });
  const [isFiltered, setIsFiltered] = useState(false);
  const [page, setPage] = useState(1);
  const itemsPerPage = 20;
  const [pages, setPages] = useState(1);
  const [ageValue, setAgeValue] = useState([18, 100]); // Keep ageValue separate for slider
  const [showFilter, setShowFilter] = useState(false); // State for filter visibility

  const [loading, setLoading] = useState(true);
  const [crewList, setCrewList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  // New states for crew selection
  const { selectedIds, handleSelectionChange, resetSelection } = useTalentSelection(); // Use the custom hook

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");


  const triggerAlert = (message, severity) => {
      setAlertMessage(message);
      setAlertSeverity(severity);
      setOpenSnackbar(true);
  };

  const handleSubmit = () => {
      if (!selectedIds.length) { // Use selectedIds from the hook
          triggerAlert("Please select Crews to send invitation.", "error");
      } else {
          openModal();
      }
  };

  const openModal = () => {
      setIsModalOpen(true);
  };

  const resetAndCloseModal = () => { // Renamed to avoid conflict with hook's resetSelection
      resetSelection(); // Call resetSelection from the hook
      closeModal();
  };

  const closeModal = () => {
      setIsModalOpen(false);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleChange = (event, value) => {
    setPage(value);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const GetAllCrews = async () => {
    nprogress.start();
    try {
      const res = await getAllCrews();
      // console.log("res from func", res);
      if (res.success) {
        setCrewList(res.users.crewProfiles);
      }
    } catch (error) {
      // console.log("error fetching crews", error);
    } finally {
      nprogress.done();
      setLoading(false);
    }
  };

  useEffect(() => {
    GetAllCrews();
  }, []);

  useEffect(() => {
    setFilteredData(crewList);
  }, [crewList]);

  useEffect(() => {
    setIsFiltered(Object.values(searchInputs).some((input) => {
      if (Array.isArray(input)) {
        return input.length > 0;
      }
      // Check for age filter, if it's not default [18,100] then it's filtered
      if (Array.isArray(input) && input.length === 2 && input[0] === 18 && input[1] === 100) {
        return false;
      }
      return input !== "";
    }) || searchInputs.jobTitles !== "" // Check if jobTitles is not empty string
    );
  }, [searchInputs]);

  const applyFilters = (filters) => {
    let filtered = crewList;

    if (filters.name) {
      filtered = filtered.filter((item) =>
        item.user.firstName.toLowerCase().includes(filters.name.toLowerCase()) ||
        item.user.lastName.toLowerCase().includes(filters.name.toLowerCase())
      );
    }

    if (filters.age && (filters.age[0] !== 18 || filters.age[1] !== 100)) { // Check if age filter is applied
      filtered = filtered.filter(
        (item) =>
          item.profile?.age >= filters.age[0] &&
          item.profile?.age <= filters.age[1]
      );
    }
    if (filters.gender.length > 0) {
      filtered = filtered.filter((item) =>
        filters.gender.includes(
          item?.user?.gender?.toLowerCase() ||
          item?.profile?.gender?.toLowerCase()
        )
      );
    }
    if (filters.ethnicity.length > 0) {
      filtered = filtered.filter((item) =>
        filters.ethnicity.includes(
          item.profile?.ethnicity?.toLowerCase() ||
          item.user?.ethnicity?.toLowerCase()
        )
      );
    }
    // New job titles filter (single selection)
    if (filters.jobTitles) {
      const selectedJobTitle = filters.jobTitles.toLowerCase();
      filtered = filtered.filter((item) => {
        const itemCategory = (item.profile?.category || "").toLowerCase();
        const itemIndustryJob = (item.profile?.industryJob || "").toLowerCase();
        return (
          itemCategory.includes(selectedJobTitle) ||
          itemIndustryJob.includes(selectedJobTitle)
        );
      });
    }


    setFilteredData(filtered);
    setPage(1);
    // window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleCheckboxChange = (field, value) => (e) => {
    const newValues = e.target.checked
      ? [...(searchInputs[field] || []), value]
      : (searchInputs[field] || []).filter((v) => v !== value);

    setSearchInputs({
      ...searchInputs,
      [field]: newValues,
    });

    handleSearch({
      ...searchInputs,
      [field]: newValues,
    });
  };

  const handleSearch = (filters) => {
    applyFilters(filters);
  };

  const handleAgeChange = (event, newValue) => {
    setAgeValue(newValue);
    setSearchInputs((prev) => ({ ...prev, age: newValue })); // Update age in searchInputs
    applyFilters({ ...searchInputs, age: newValue });
  }

  useEffect(() => {
    const pageCount = Math.ceil(filteredData.length / itemsPerPage);
    setPages(pageCount || 1);
  }, [filteredData]);

  const handleResetFilters = () => {
    setSearchInputs({
      name: "",
      country: "",
      zip: "",
      radius: "",
      age: [18, 100], // Reset age to default range
      gender: [],
      hobby: "",
      eyeColor: [],
      hairColor: [],
      weight: "",
      height: "",
      ethnicity: [],
      jobTitles: "", // Clear job titles on reset
    });
    setAgeValue([18, 100]); // Reset age slider value
    setFilteredData(crewList); // Reset filtered data to original list
    setPage(1);
  };

  const crewCount = filteredData?.length;
  const paginatedData = filteredData?.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  if (loading) {
    return (
      <div className="spinner-page">
        <Spinner className="spinner" />
      </div>
    );
  }

  const handlePagination = (e, value) => {
    setPage(value);
  };

  return (
    <div className="castingCall-list-full-wrapper">
      <div className="castingCall-list-conainer">
        {/* <div className="castingCall-clear-filter mt-5"> */}
         <div
          className="castingCall-clear-filter"
          style={{
            display: "flex",
            flexDirection: window.innerWidth < 768 ? "column" : "row",
          }}
        >
          {/* <Typography
            variant="h5"
            style={{ color: theme.palette.primary.main, fontWeight: 600 }}
          > */}
          <Typography
            variant="h5"
            sx={{
              color: theme.palette.primary.main,
              fontWeight: 600,
              fontSize: {
                xs: "18px",
                sm: "20px",
                md: "20px",
                lg: "24px",
              },
            }}
          >
            {crewCount} Active Crews
          </Typography>
          <Button
            variant="outlined"
            onClick={() => setShowFilter(!showFilter)}
            style={{
           
            width: window.innerWidth < 768 ? "100%" : "auto",
          }}
            sx={{ display: { xs: 'flex', md: 'none' } }} // Show on small screens
            startIcon={showFilter ? <CloseIcon /> : <FilterListIcon />}
          >
            {showFilter ? 'Hide Filters' : 'Show Filters'}
          </Button>
          {isFiltered && ( // Show reset filter button only if filters are applied
            <div onClick={handleResetFilters} className="filter-clear">
              Reset filters
            </div>
          )}
        </div>
        <div className="seperate-line mb-4"></div>
        <Box
          sx={{
            width: "100%",
            display: "flex",
              gap: {
      xs: "10px",  
      sm: "20px",  
      md: "20px",  
      xl: "40px",  
    },
            flexDirection: { xs: 'column', md: 'row' } // Stack on small, side-by-side on medium+
          }}
        >
          <Box sx={{ flex: '1 1 auto' }}> {/* Crew List */}
            <div className="castingCall-list">
              { (userRole === "producer" || userRole === "director") && (
                  <div className="button-container">
                  <FontAwesomeIcon icon={faEnvelope} className="envelop" />
                      <button onClick={handleSubmit} >
                      Send Invitation
                      </button>
                  </div>
              )
              }
              {paginatedData.length === 0 && (
                <Typography
                  variant="h5"
                  sx={{ color: `${theme.palette.text.secondary}` }}
                >
                  No Crews Found
                </Typography>
              )}
              {/* <ActorsSelectingList actors={paginatedData} /> */}
              <div className="actorList"> {/* Reusing actorList class for styling */}
                {paginatedData.map((crew) => (
                  <ActorCard // Using ActorCard for crew
                      key={crew.user.id}
                      actor={crew}
                      userRole={userRole}
                      selectedCrewIds={selectedIds} // Pass selectedIds from the hook
                      handleCrewSelectionChange={handleSelectionChange} // Pass handleSelectionChange from the hook
                  />
                ))}
              </div>
              <div className="pagination">
                <Pagination
                  count={pages}
                  page={page}
                  onChange={handleChange}
                  color="primary"
                />
              </div>
            </div>
          </Box>
          <Box
            sx={{
              flex: '0 0 250px', // Fixed width on larger screens
              maxWidth: { xs: '100%', md: '250px' }, // Max width for filter
              display: { xs: showFilter ? 'flex' : 'none', md: 'flex' }, // Toggle visibility on small, always show on medium+
              flexDirection: 'column',
              gap: '20px',
            }}
          >
            <CrewSearchFilter
              searchInputs={searchInputs}
              setSearchInputs={setSearchInputs}
              handleSearch={handleSearch}
              ageValue={ageValue}
              handleAgeChange={handleAgeChange}
            />
          </Box>
        </Box>
      </div>
      <Alert
        openSnackbar={openSnackbar}
        alertSeverity={alertSeverity}
        setOpenSnackbar={setOpenSnackbar}
        alertMessage={alertMessage}
      />

      <InvitationPopUp
        closeModal={closeModal}
        isModalOpen={isModalOpen}
        producerId={producerId}
        selectedActorsIds={selectedIds} // Passing selectedIds from the hook
        resetSelection={resetAndCloseModal}
      />
    </div>
  );
};

export default CrewList;
